export interface BioPageLink {
  id: string;
  label: string;
  url: string;
  icon?: string;
  active: boolean;
}

export interface BioPageSocial {
  platform: 'instagram' | 'twitter' | 'linkedin' | 'facebook' | 'youtube' | 'github' | 'tiktok';
  url: string;
  active: boolean;
}

export interface BioPageLeadForm {
  enabled: boolean;
  title: string;
  description: string;
  buttonText: string;
  successMessage: string;
  fields: {
    name: boolean;
    email: boolean;
    phone: boolean;
    message: boolean;
  };
}

export interface BioPageData {
  profileName: string;
  bio: string;
  profileImageUrl?: string;
  theme: 'modern' | 'glass' | 'neon' | 'minimal' | 'vintage';
  primaryColor: string;
  links: BioPageLink[];
  socials: BioPageSocial[];
  slug?: string;
  leadForm?: BioPageLeadForm;
}

export const defaultBioPageData: BioPageData = {
  profileName: '',
  bio: '',
  theme: 'modern',
  primaryColor: '#7c3aed',
  links: [
    { id: '1', label: 'My Website', url: 'https://example.com', active: true },
  ],
  socials: [
    { platform: 'instagram', url: '', active: false },
    { platform: 'twitter', url: '', active: false },
    { platform: 'linkedin', url: '', active: false },
  ],
  leadForm: {
    enabled: false,
    title: 'Get in Touch',
    description: 'Leave your details and I will get back to you.',
    buttonText: 'Submit',
    successMessage: 'Thanks! I will be in touch soon.',
    fields: {
      name: true,
      email: true,
      phone: false,
      message: true,
    }
  }
};

export function bioPageToContentData(data: BioPageData): Record<string, string> {
  return {
    bioPageData: JSON.stringify(data),
    slug: data.slug || '',
  };
}

export function contentDataToBioPage(contentData: Record<string, string>): BioPageData {
  if (contentData.bioPageData) {
    try {
      return JSON.parse(contentData.bioPageData);
    } catch (e) {
      console.error('Failed to parse bioPageData:', e);
    }
  }
  return defaultBioPageData;
}
